/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ProjectCredentials
 */
export interface ProjectCredentials {
    /**
     * 
     * @type {string}
     * @memberof ProjectCredentials
     */
    projectAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCredentials
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCredentials
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCredentials
     */
    value?: string;
}

export function ProjectCredentialsFromJSON(json: any): ProjectCredentials {
    return ProjectCredentialsFromJSONTyped(json, false);
}

export function ProjectCredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectCredentials {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectAccountId': !exists(json, 'projectAccountId') ? undefined : json['projectAccountId'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function ProjectCredentialsToJSON(value?: ProjectCredentials | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectAccountId': value.projectAccountId,
        'projectId': value.projectId,
        'key': value.key,
        'value': value.value,
    };
}

/**
 * 
 * @export
 * @interface ProjectCredentialsInput
 */
export interface ProjectCredentialsInput {
    /**
     * 
     * @type {string}
     * @memberof ProjectCredentialsInput
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCredentialsInput
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCredentialsInput
     */
    data?: string;
}

export function ProjectCredentialsInputFromJSON(json: any): ProjectCredentialsInput {
    return ProjectCredentialsInputFromJSONTyped(json, false);
}

export function ProjectCredentialsInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectCredentialsInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function ProjectCredentialsInputToJSON(value?: ProjectCredentialsInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectId': value.projectId,
        'key': value.key,
        'data': value.data,
    };
}

/**
 * 
 * @export
 * @interface UpdateProjectCredentialsDto
 */
export interface UpdateProjectCredentialsDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProjectCredentialsDto
     */
    projectAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProjectCredentialsDto
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProjectCredentialsDto
     */
    value?: string;
}

export function UpdateProjectCredentialsDtoFromJSON(json: any): UpdateProjectCredentialsDto {
    return UpdateProjectCredentialsDtoFromJSONTyped(json, false);
}

export function UpdateProjectCredentialsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProjectCredentialsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectAccountId': !exists(json, 'projectAccountId') ? undefined : json['projectAccountId'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function UpdateProjectCredentialsDtoToJSON(value?: UpdateProjectCredentialsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectAccountId': value.projectAccountId,
        'key': value.key,
        'value': value.value,
    };
} 